import translate from 'rcm-i18n';
import React, {Component} from 'react';

interface Props {
    onClick: () => void;
}

export default class AddToCartButtonComponent extends Component<Props> {
    public render() {
        return (
            <button onClick={this.props.onClick}
                    className="btn btn-primary pull-right clearfix">
                        {translate('Add to Cart')}
            </button>
        );
    }
}
